module.exports = __webpack_public_path__ + "img/dining-chairs.80f8d7b.jpg";